var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 68"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#134A81",
    stroke: "#FFF",
    d: "M50.53 9.486c5.48 5.483 8.5 12.773 8.5 20.524 0 6.931-2.44 13.507-6.925 18.765l14.57 14.567-.706.704.707-.702a2.355 2.355 0 01-3.332 3.329L48.772 52.105a28.902 28.902 0 01-18.765 6.913c-7.651 0-15.014-2.98-20.52-8.487-11.316-11.315-11.316-29.73 0-41.045 11.32-11.315 29.729-11.315 41.044 0zM30.008 5.71a24.239 24.239 0 00-17.19 7.107c-9.383 9.382-9.479 24.59-.288 34.092l.288.292c9.48 9.48 24.905 9.478 34.383 0 4.593-4.59 7.12-10.694 7.12-17.191 0-6.498-2.527-12.6-7.12-17.193C42.586 8.204 36.422 5.71 30.007 5.71z"
  })));
}
export default SvgSearch;